import { DELETE_JOB_LISTING } from '../../endpoints';
import { JobListing } from '../../types/jobs';
import makeAuthenticatedRequest from '../base-api';

interface DeleteJobListingResponse {
  success: boolean;
  message?: string;
  jobListing?: JobListing;
}

const deleteJobListingApi = async (
  payload: JobListing
): Promise<DeleteJobListingResponse> => {
  try { 
    const response = await makeAuthenticatedRequest(DELETE_JOB_LISTING, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Delete job listing failed:', error);
    throw error;
  }
};

export { deleteJobListingApi, type DeleteJobListingResponse };
